import type { Schema } from '@wix/wix-data-schema-types'
import { SINGLES_PLUGIN_ID } from '@wix/wix-data-schema-types'

export const collectionTypes = {
  MULTI_ITEM_COLLECTION: 'MULTI_ITEM_COLLECTION',
  SINGLE_ITEM_COLLECTION: 'SINGLE_ITEM_COLLECTION',
}

export const getCollectionTypeFromSchema = ({ plugins }: Schema) => {
  return plugins?.[SINGLES_PLUGIN_ID] !== undefined
    ? collectionTypes.SINGLE_ITEM_COLLECTION
    : collectionTypes.MULTI_ITEM_COLLECTION
}

export const isSinglesCollectionSchema = (schema: Schema) =>
  getCollectionTypeFromSchema(schema) === collectionTypes.SINGLE_ITEM_COLLECTION

export const isMultiItemCollectionSchema = (schema: Schema) =>
  getCollectionTypeFromSchema(schema) === collectionTypes.MULTI_ITEM_COLLECTION
